export interface Video {
  id?: string;

  title?: string;

  description?: string;

  imageUrl?: string;
  imageAspectRatio?: number;

  link?: string;

  channelLogo?: string;
  channelName?: string;

  tags?: Array<string>;

  lang?: string | undefined;

  publishStatus?: PublishStatusType;

  createdBy?: string;
  createdById?: string;

  created?: Date;
  modified?: Date;
}

export enum PublishStatusType {
  PUBLISHED = 'published',
  REVIEW = 'review',
  DRAFT = 'draft',
  DELETED = 'deleted',
  ARCHIVED = 'archived',
}
